module.exports = __webpack_public_path__ + "img/alert.27179bc4.svg";